import { api } from './client';
import type {
  CompletedPageDto,
  CompleteTaskResponse,
  CreateTaskRequest,
  TaskDto,
  TaskListParams,
  UpdateTaskRequest
} from './types';

export function listTasks(workspaceId: string, params: TaskListParams): Promise<TaskDto[]> {
  return api<TaskDto[]>(`/workspaces/${workspaceId}/tasks`, {
    query: { view: params.view, projectId: params.projectId, tagId: params.tagId }
  });
}

export function listCompletedTasks(
  workspaceId: string,
  page: number,
  size = 50,
  projectId?: string
): Promise<CompletedPageDto> {
  return api<CompletedPageDto>(`/workspaces/${workspaceId}/tasks`, {
    query: { view: 'completed', page, size, projectId }
  });
}

export function reorderTasks(
  workspaceId: string,
  ids: string[],
  list: 'today' | 'container'
): Promise<void> {
  return api<void>(`/workspaces/${workspaceId}/tasks/reorder`, {
    method: 'POST',
    body: { ids, list }
  });
}

/** Rewrites the Priorytety manual order once by ICE score; pinned ids go first. */
export function sortTodayByIce(workspaceId: string, pinFirst: string[] = []): Promise<TaskDto[]> {
  return api<TaskDto[]>(`/workspaces/${workspaceId}/tasks/today/sort-by-ice`, {
    method: 'POST',
    body: { pinFirst }
  });
}

export function createTask(workspaceId: string, body: CreateTaskRequest): Promise<TaskDto> {
  return api<TaskDto>(`/workspaces/${workspaceId}/tasks`, { method: 'POST', body });
}

export function getTask(taskId: string): Promise<TaskDto> {
  return api<TaskDto>(`/tasks/${taskId}`);
}

export function updateTask(taskId: string, body: UpdateTaskRequest): Promise<TaskDto> {
  return api<TaskDto>(`/tasks/${taskId}`, { method: 'PATCH', body });
}

export function completeTask(taskId: string): Promise<CompleteTaskResponse> {
  return api<CompleteTaskResponse>(`/tasks/${taskId}/complete`, { method: 'POST' });
}

export function uncompleteTask(taskId: string): Promise<TaskDto> {
  return api<TaskDto>(`/tasks/${taskId}/uncomplete`, { method: 'POST' });
}

export function deleteTask(taskId: string): Promise<void> {
  return api<void>(`/tasks/${taskId}`, { method: 'DELETE' });
}
